export default "__VITE_ASSET__Xx$tTgdE__"